export default __webpack_public_path__ + "static/media/switchesSolution.a9e39f7c.png";